import { observer } from 'mobx-react'
import React from 'react'
import usePortManager from '../hooks/use-port-manager'
import ArrowLinkBox from '../misc/ArrowLinkBox'
import Modal from 'react-modal'
import InputWrapper from '../inputs/InputWrapper'
import { action, computed, observable } from 'mobx'
import { mttAjax } from '../../../utils/_mtt-ajax'
import useSettingsManager from '../hooks/use-settings-manager'
import Spinner from '../misc/Spinner'
import CopyInput from '../inputs/CopyInput'

class ShareState {
  @observable accessor portSelection = new Map()
  @observable accessor success_message = null
  @observable accessor error_message = null
  @observable accessor is_loading = false
  @observable accessor is_sent = false
  @observable accessor share_url = null

  @action setValue(key, value) {
    this[key] = value
  }

  @computed get ports () {
    let data = window.localStorage.getItem('ports')
    try {
      data = JSON.parse(data)
      return typeof data === 'object' && data !== null ? data : []
    } catch (e) {
      return []
    }
  }

  @computed get selectedPorts () {
    let ports = this.ports
    return ports.filter(p => {
      return this.isPortSelected(p.port_id)
    })
  }

  @action
  submit () {
    this.success_message = null
    this.error_message = null
    this.is_loading = true

    mttAjax(
      'nassau_save_tmp',
      { action: 'nassau_port_config_save_ports_tmp', ports: this.selectedPorts },
      r => {
        if (r.success === true) {
          ga('send','event', 'share','port-config')
          this.setValue('share_url', r.data.url)
          this.is_sent
        }
        this.setValue('is_loading', false)
      }
    )
  }

  @action togglePort (port_id) {
    let selected = this.portSelection.get(port_id)
    this.portSelection.set(port_id, !selected)
  }

  isPortSelected (port_id) {
    return Boolean(this.portSelection.get(port_id))
  }
}

const shareState = new ShareState()

function ShareModal () {
  const portManager = usePortManager()

  const settings_manager = useSettingsManager()

  const share_link_title = settings_manager.getOtherSettings(
    'share_link_title',
    'Del port konfiguration'
  )
  const share_link_description = settings_manager.getOtherSettings(
    'share_link_description',
    'Få et link som du kan dele'
  )
  const shareModalDescription = settings_manager.getOtherSettings(
    'share_modal_description',
    'Kopier nedenstående link og del det. så kan de se de porte du har konfigureret'
  )
  const shareModalTitle = settings_manager.getOtherSettings(
    'share_modal_title',
    'Del porte'
  )
  const shareModalDoneText = settings_manager.getOtherSettings(
    'share_modal_done_text',
    'Færdig'
  )
  const shareModalUrlLabel = settings_manager.getOtherSettings(
    'share_modal_url_label',
    'Link til deling'
  )

  const [modalIsOpen, setModalIsOpen] = React.useState(false)

  const openModal = React.useCallback(() => setModalIsOpen(true), [
    setModalIsOpen
  ])

  const closeModal = React.useCallback(() => {
    setModalIsOpen(false)
    shareState.setValue('is_loading', false)
    shareState.setValue('is_sent', false)
    shareState.setValue('success_message', null)
    shareState.setValue('error_message', null)
    shareState.setValue('share_url', null)
  }, [setModalIsOpen])

  const [url_copied, set_url_copied] = React.useState(false)

  return (
    <>
      <ArrowLinkBox title={share_link_title} description={share_link_description} onClick={openModal}/>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel={share_link_title}
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            width: 'auto',
            maxWidth: 800
          }
        }}
      >
        <div id={'port-configurator'} className={'port-drawing'}>
          <form
            className={'final-step'}
            onSubmit={e => {
              e.preventDefault()
              shareState.submit()
            }}
          >
            {shareState.share_url ? (
              <>
                <InputWrapper name={shareModalTitle}>
                  <div className="share-modal-description" dangerouslySetInnerHTML={{ __html: shareModalDescription }}/>
                  <CopyInput value={shareState.share_url} label={shareModalUrlLabel}
                             copyMessage={settings_manager.getOtherSettings(
                               'share_port_copied',
                               'Link kopiret til udklipsholder'
                             )}/>
                </InputWrapper>
                <div className={'simple-step-nav'} style={{ justifyContent: 'flex-end' }}>
                  <button className={'next button primary'} onClick={closeModal}>
                    {shareModalDoneText}
                  </button>
                </div>
              </>
            ) : (
              <>
                <InputWrapper name={shareModalTitle}>
                  <aside
                    className={'input input-text input-box'}
                    data-size="full"
                  >
                    <div className={'input-box__title'}>
                      {settings_manager.getOtherSettings(
                        'share_port_selection',
                        'Vælg hvilke Porte du vil dele'
                      )}
                    </div>
                    <div className={'port-overview-nav'}>
                      {portManager.ports.map((port, index) => (
                        <button
                          type={'button'}
                          key={index}
                          onClick={() => shareState.togglePort(port.port_id)}
                          data-active={shareState.isPortSelected(
                            port.port_id
                          )}
                        >
                          {port.name}
                        </button>
                      ))}
                    </div>
                  </aside>
                  {shareState.is_loading ? (
                    <div className={'input-box'}>
                      <Spinner/>
                    </div>
                  ) : (
                    <div className={'input-box'} data-size="full">
                      <button
                        className={'button primary'}
                        type={'submit'}
                        disabled={
                          shareState.is_sent || shareState.is_loading
                        }
                      >
                        {settings_manager.getOtherSettings(
                          'share_port_action',
                          'Opret link til deling af porte'
                        )}
                      </button>
                    </div>
                  )}
                </InputWrapper>
                {shareState.error_message ? (
                  <div
                    style={{ marginTop: '12px' }}
                    dangerouslySetInnerHTML={{
                      __html: shareState.error_message
                    }}
                  />
                ) : null}
              </>
            )}
          </form>
        </div>
      </Modal>
    </>
  )
}

export default observer(ShareModal)